export const API_GET_RATINGS = "API_GET_RATINGS"
export const RESET_RATINGS = "RESET_RATINGS"
